import React from 'react';

import {Button, RandomWhale} from '@ergeon/core-components';

type ErrorFallbackScreenProps = {
  /** Dashboard navigation, injectable for tests (jsdom cannot mock location). */
  onNavigateHome?: () => void;
  /**
   * Offer a way back to a working screen. Both boundaries enable this; it stays
   * opt-in so the screen can also be used where navigation makes no sense.
   */
  showNavigation?: boolean;
};

// Full document navigation on purpose: it discards whatever app state crashed
// the route instead of carrying it to the dashboard.
const navigateHome = () => window.location.assign('/');

// Actions go through RandomWhale's own `actions` slot rather than sitting
// beside it: the slot places them under the title/description block and applies
// the responsive stacking (column on mobile, row from sm up) that every other
// whale screen gets. Rendering the button as a sibling skipped both.
const ErrorFallbackScreen = ({onNavigateHome = navigateHome, showNavigation = false}: ErrorFallbackScreenProps) => {
  const actions = showNavigation ? (
    <Button onClick={onNavigateHome} size="large">
      Back to Dashboard
    </Button>
  ) : undefined;

  return (
    <div
      className="flex flex-col justify-center items-center h-screen overflow-hidden"
      data-testid="Error-fallbackScreen"
    >
      <RandomWhale actions={actions} />
    </div>
  );
};

export default ErrorFallbackScreen;
